import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Grid, Typography, Divider, Button } from '@mui/material';

export default function ViewActionImpl() {
    const { productassetObj } = useSelector((state) => state.pharmaslice.productassetDashboard);
    const { selectedImagePath, selectedImage } = useSelector((state) => state.imagegalleryslice);

    useEffect(() => {}, []);

    const handleDownload = () => {
        const fileName = selectedImage || 'asset-image';
        fetch(selectedImagePath)
            .then(response => response.blob())
            .then(blob => {
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            });
    };

    return (
        <Grid container sx={{ overflowY: "scroll", width: '100%', height: '75vh', justifyContent: "center", alignItems: "center" }}>
            <div style={{ textAlign: "center" }}>
                <img src={selectedImagePath} alt="Selected" style={{ width: '100%', height: '100%' }} />
                <Button
                    variant="outlined"
                    sx={{ mt: 2 }}
                    onClick={handleDownload}
                >
                    Download Image
                </Button>
            </div>
        </Grid>
    );
}